module.exports = ReactRedux;


//////////////////
// WEBPACK FOOTER
// external "ReactRedux"
// module id = 7
// module chunks = 0